import { Spin } from "antd";

import { FIELD_PREVIEW_DEFAULT_VALUE } from "@/components/Elements/FieldPreview/FieldPreview.constant";
import { isDataEmpty } from "@/utilities/data";

const FieldPreviewWrapper = ({ value, children, loading }) => {
  if (loading) return <Spin size="small" />;

  if (isDataEmpty(value)) return FIELD_PREVIEW_DEFAULT_VALUE;

  return children;
};

export default FieldPreviewWrapper;
